<template>
    <div class="site-left">
        <boxTitle :title="'电池信息'" :subtitle="'Battery information'"></boxTitle>
        <divBox class="all-round">
            <template>
                <div>
                    <boxList :list="allRoundData" :line="2"></boxList>
                </div>
            </template>
        </divBox>

        <boxTitle style="margin-top: 30px" :title="'电池指标'" :subtitle="'Battery index'"></boxTitle>
        <div class="battery-info" style="margin-top: 20px">
            <div>
                <div class="info-item">
                    <div class="item-label">电池编号：</div>
                    <div class="item-value">{{ batteryData.batteryNumber }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">生&nbsp;&nbsp;产&nbsp;&nbsp;商：</div>
                    <div class="item-value">{{ batteryData.production }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">电池类型：</div>
                    <div class="item-value">{{ batteryData.batteryModel }}</div>
                </div>
            </div>
            <!-- <div>
                <div class="info-item">
                    <div class="item-label">适用车型：</div>
                    <div class="item-value">{{ batteryData.batteryType }}</div>
                </div>
            </div> -->
            <!-- <div>
                <div class="info-item">
                    <div class="item-label">硬件版本：</div>
                    <div class="item-value">{{ batteryData.hardwareVersion }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">软件版本：</div>
                    <div class="item-value">{{ batteryData.softwareVersion }}</div>
                </div>
            </div> -->
            <div>
                <div class="info-item">
                    <div class="item-label">交付日期：</div>
                    <div class="item-value">{{ batteryData.deliveryDate || '2021/12/1'}}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">质保年限：</div>
                    <div class="item-value">{{ batteryData.warrantyPeriod }}年</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">额定电压：</div>
                    <div class="item-value">{{ parseInt(batteryData.ratedVoltage, 10) }}V</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">额定容量：</div>
                    <div class="item-value">{{ parseInt(batteryData.ratedTotalEnergy, 10) }}kWh</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">质保里程：</div>
                    <div class="item-value">{{ parseInt(batteryData.warrantyMileage, 10) }}wkm</div>
                </div>
            </div>
            <!-- <div>
                <div class="info-item">
                    <div class="item-label">资产属性：</div>
                    <div class="item-value">{{ batteryData.batteryBelong }}</div>
                </div>
            </div> -->
        </div>

    </div>
</template>

<script>
import boxTitle from '../../components/boxTitle.vue'
import divBox from '../../components/divBox.vue'
import boxList from '../../components/boxList.vue'

import { dataInterface } from '@/api/dataInterfaceApi'
export default {
    components: {
        boxTitle,
        divBox,
        boxList
    },
    props: {
        allRoundData: {
            type: Array,
            default: () => { return []}
        }
    },
    data() {
        return {
            batteryId: '',
            batteryData: {}
        }
    },
	// inject: ['batteryId'],
    inject: ['batteryObj'],
    computed: {
        computedProperty() {
            return this.batteryObj()
        }
    },
    watch: {
        computedProperty(val) {
            this.batteryId = val.value
		    this.init()
        },
    },
    mounted() {
    },
    methods: {
        init() {
            this.getBatteryInfo()
        },
        // 电池单体信息
		getBatteryInfo() {
			let _this = this
			let params = {
				"enCode": "TiDB-Energy-dianchixiang-dianchizhibiao",
				"@battery_id": _this.batteryId
			}
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if(!res || !res.length) return
                    _this.batteryData = res[0] || {}
                })
                    .catch((err) => {
                    console.log(err);
			    })
        }
    }
}
</script>

<style lang="scss" scoped>
.site-left {
    margin-top: 20px;
    .all-round {
        padding: 15px 0;
        margin-top: 20px;
    }
    .battery-info {
        display: flex;
        flex-wrap: wrap;
        > div {
            width: 90%;
            box-sizing: border-box;
            // &:nth-child(odd) {
            //     padding-right: 5px;
            // }
            // &:nth-child(even) {
            //     padding-left: 5px;
            // }
            padding-bottom: 5px;
        }
        .info-item {
            background: #01B1A9 linear-gradient(180deg, rgba(14,134,139,0.88) 0%, rgba(0,43,41,0.6) 100%);
            height: 70px;
            font-size: 20px;
            display: flex;
            align-items: center;
            margin-top: 10px;
            .item-label {
                width: 130px;
                flex-shrink: 0;
                // display: flex;
                text-align: right;
                &.w1 {
                    width: 140px;
                }
            }
            .item-value {
                flex: 1;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
    }
}
</style>